import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { ApiConfig } from '../../../shared/services/api/config.api';
import { HttpClient } from '@angular/common/http';
import { throwError as observableThrowError } from 'rxjs';

@Injectable()
export class SendWelcomeMailService {
  constructor(public httpClient: HttpClient) {
  }

  getUser(empId, certNo, pNum, pSize) {
    return this.httpClient.get(ApiConfig.baseURL + 'api/admin/sendwelcomeemail/page?employeeId=' + empId + '&certNo=' + certNo + '&page=' + pNum + '&size=' + pSize);
  }

  sendWelcomeMail(userId) {
    return this.httpClient.post(ApiConfig.baseURL + 'api/admin/sendwelcomeemail/' + userId, ApiConfig.requestOptionsHeader).pipe(
      catchError((error: any) => observableThrowError(error.json().error || 'Server error')));
  }
}
